import { render, staticRenderFns } from "./CartHoraireShops.vue?vue&type=template&id=f6a60c1c&scoped=true&"
import script from "./CartHoraireShops.vue?vue&type=script&lang=js&"
export * from "./CartHoraireShops.vue?vue&type=script&lang=js&"
import style0 from "./CartHoraireShops.vue?vue&type=style&index=0&id=f6a60c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a60c1c",
  null
  
)

export default component.exports